module.exports = __webpack_public_path__ + "static/media/cup2.4a1fa561.jpg";